module.exports = ".banner {\r\n    position: absolute;\r\n    top:0px;\r\n    margin-top: 55px;\r\n    margin-left: -4px;\r\n}\r\n\r\n.banner>.img-fluid {\r\n    max-width: 80%;\r\n    height: auto;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shoppingcart/cart-items/cart-items.component.css
// module id = ./src/app/shoppingcart/cart-items/cart-items.component.css
// module chunks = main